import script from "./PortfolioRiskReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioRiskReportView.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioRiskReportView.vue?vue&type=style&index=0&id=54faa8a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54faa8a7"]])

export default __exports__